import { dao } from '@platform/dao';
import type { IObserverOffice, IObserverOffices, IPlatformUser } from '@platform/dao';
import type { IPlatformAccountsArg } from './args/IPlatformAccountsArg';
import { baseApi, run } from './baseApi';

/** Тег облікових записів платформи — спільний із «Глобальними ролями» (adminApi): зміна стану оновлює обидві сторінки. */
const accountsTag = { type: 'Roles' as const, id: 'platform' };
const officesTag = { type: 'Workspaces' as const, id: 'observer-offices' };

/**
 * Очищення платформи (рішення 5 етапу 7, лише адміністратор платформи; сервер перевіряє права й пише аудит): облікові записи з відбором за
 * станом, деактивація (вхід і сесії припиняються, записи й журнал аудиту лишаються) і відновлення; демо-офіси спостерігача — перелік,
 * скидання (офіс створюється заново, з новим ідентифікатором) і видалення. Зміни офісів оновлюють і каталог просторів.
 */
export const platformAdminApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    platformAccounts: b.query<IPlatformUser[], IPlatformAccountsArg>({
      queryFn: ({ q, status }) => run(() => dao.platform.users(q || undefined, status)),
      providesTags: [accountsTag],
    }),
    deactivateUser: b.mutation<IPlatformUser, string>({ queryFn: (id) => run(() => dao.platform.deactivateUser(id)), invalidatesTags: [accountsTag] }),
    reactivateUser: b.mutation<IPlatformUser, string>({ queryFn: (id) => run(() => dao.platform.reactivateUser(id)), invalidatesTags: [accountsTag] }),
    observerOffices: b.query<IObserverOffices, void>({ queryFn: () => run(() => dao.platform.observerOffices()), providesTags: [officesTag] }),
    resetObserverOffice: b.mutation<IObserverOffice, string>({ queryFn: (id) => run(() => dao.platform.resetObserverOffice(id)), invalidatesTags: ['Workspaces'] }),
    deleteObserverOffice: b.mutation<void, string>({ queryFn: (id) => run(() => dao.platform.deleteObserverOffice(id)), invalidatesTags: ['Workspaces'] }),
  }),
});

export const {
  usePlatformAccountsQuery, useDeactivateUserMutation, useReactivateUserMutation, useObserverOfficesQuery, useResetObserverOfficeMutation,
  useDeleteObserverOfficeMutation,
} = platformAdminApi;
